import { Card, PageHeader } from "../../components/shared/UIComponents";
import { useAuth } from "../../context/AuthContext";
import { SuperAdminAPI, AdminMgmtAPI } from "../../services/api";
import { useAsyncData } from "../../hooks/useAsyncData";

export default function SADash({ setPage }) {
  const { user } = useAuth();
  const { data: admins,    loading: la } = useAsyncData(() => AdminMgmtAPI.getAll());
  const { data: societies, loading: ls } = useAsyncData(() => SuperAdminAPI.getAllSocieties());

  const activeAdmins = admins.filter(a => a.active !== false && a.status !== "Inactive").length;
  const stats = [
    { label:"Total Admins",     value: la ? "…" : admins.length,       color:"#1a6fc4", bg:"#e8f1fb", icon:"👤" },
    { label:"Active Admins",    value: la ? "…" : activeAdmins,        color:"#0f9d58", bg:"#e6f4ea", icon:"✅" },
    { label:"Total Societies",  value: ls ? "…" : societies.length,    color:"#f57c00", bg:"#fff3e0", icon:"🏢" },
    { label:"Inactive Admins",  value: la ? "…" : admins.length - activeAdmins, color:"#d32f2f", bg:"#fce8e6", icon:"⚠️" },
  ];

  return (
    <div>
      <PageHeader title={`Welcome, ${user?.name || "Super Admin"}`} sub="System overview and quick actions" />
      <div style={{ padding:"0 0 24px", display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:16, marginBottom:24 }}>
        {stats.map(s => (
          <div key={s.label} style={{ background:"#fff", borderRadius:12, padding:"18px 20px", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", borderLeft:`4px solid ${s.color}` }}>
            <div style={{ fontSize:26, marginBottom:6 }}>{s.icon}</div>
            <div style={{ fontSize:26, fontWeight:800, color:s.color }}>{s.value}</div>
            <div style={{ fontSize:12, color:"#78909c", fontWeight:500, marginTop:2 }}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
        <Card>
          <div style={{ padding:20 }}>
            <div style={{ fontWeight:700, fontSize:14, color:"#1a2744", marginBottom:14 }}>Quick Actions</div>
            {[["Create New Admin","sa-create","#1565c0"],["View All Admins","sa-list","#0f9d58"],["View Societies","sa-societies","#f57c00"],["Settings","sa-settings","#7b1fa2"]].map(([label,page,color]) => (
              <button key={page} onClick={()=>setPage(page)} style={{ width:"100%", padding:"11px 14px", marginBottom:8, background:"#f5f7fa", border:"none", borderRadius:8, cursor:"pointer", textAlign:"left", fontSize:13, fontWeight:500, color:"#263238", display:"flex", alignItems:"center", gap:10, transition:"background 0.15s" }}
                onMouseEnter={e=>e.currentTarget.style.background="#e3f2fd"} onMouseLeave={e=>e.currentTarget.style.background="#f5f7fa"}>
                <span style={{ width:8, height:8, borderRadius:"50%", background:color, flexShrink:0 }} />
                {label}
              </button>
            ))}
          </div>
        </Card>
        <Card>
          <div style={{ padding:20 }}>
            <div style={{ fontWeight:700, fontSize:14, color:"#1a2744", marginBottom:14 }}>Recent Admins</div>
            {la && <div style={{ color:"#78909c", fontSize:13 }}>Loading…</div>}
            {!la && admins.slice(0, 5).map(a => (
              <div key={a.id} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 0", borderBottom:"1px solid #f0f2f5" }}>
                <div style={{ width:32, height:32, borderRadius:"50%", background:`hsl(${(a.id||1)*80},60%,45%)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, color:"#fff", fontWeight:700 }}>{(a.name||"A")[0]}</div>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:"#263238" }}>{a.name}</div>
                  <div style={{ fontSize:11, color:"#90a4ae" }}>{a.email}</div>
                </div>
                <span style={{ padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, background: a.active!==false&&a.status!=="Inactive"?"#e6f4ea":"#fce8e6", color: a.active!==false&&a.status!=="Inactive"?"#0f9d58":"#d32f2f" }}>
                  {a.active!==false&&a.status!=="Inactive"?"Active":"Inactive"}
                </span>
              </div>
            ))}
            {!la && admins.length === 0 && <div style={{ color:"#90a4ae", fontSize:13 }}>No admins yet.</div>}
          </div>
        </Card>
      </div>
    </div>
  );
}
